import React, { useState, useEffect } from "react";
import Card from "./Card";


function App() {
  
  return (
    <Card />
  );
}

export default App;
